import React from 'react';
import PropTypes from 'prop-types';

const PublicUrl = ({ title, publicUrl, slug, message, cta, ctaLink }) => (
  <div className="public-url__container">
    <h3 className="public-url__title">{title}</h3>
    <span className="public-url__url">{publicUrl}/<span className="public-url__slug">{slug}</span></span>
    <div className="public-url__message">{message} <a className="public-url__cta" href={ctaLink} target="_self">{cta}</a></div>
  </div>
);

PublicUrl.propTypes = {
  title: PropTypes.string,
  publicUrl: PropTypes.string,
  slug: PropTypes.string,
  message: PropTypes.string,
  cta: PropTypes.string,
  ctaLink: PropTypes.string
};

export default PublicUrl;



/** WEBPACK FOOTER **
 ** ./src/components/settings/url/PublicUrl.jsx
 **/